import Tabs from './Tabs'
import Tab from './Tab'

export default {
  Tabs,
  Tab
}
